'use client';

import { useRef } from 'react';
import PageType from '@alltrails/amplitude/enums/PageType';
import useLogWebSectionViewed from '@alltrails/layout/hooks/useLogWebSectionViewed';
import { LocationDetailsApiResponse } from '@/types/locationDetailsPages/shared';
import { SubLocationDetailsApiResponse } from '@/types/subLocationListPages/shared';
import PageSection from '../layouts/PageSection';
import TopModuleSection from './TopModuleSection';

type Props = {
  details: LocationDetailsApiResponse | SubLocationDetailsApiResponse;
  pageType?: PageType;
};

const TopModule = ({ details, pageType }: Props) => {
  const locationType = details.locationType;
  const topModules = details?.rivers;
  const ref = useRef<HTMLDivElement>(null);
  useLogWebSectionViewed(ref, 'Top Modules', pageType, { threshold: 0.5 });

  if (!topModules || !topModules.length) {
    return null;
  }

  return (
    <>
      {topModules?.map?.((topModule, index) => {
        if (!topModule.items.length) {
          return null;
        }
        const locationNameForParkPage = locationType === 'park' ? (details.cityName ?? details.stateName ?? details.countryName) : undefined;

        return (
          <PageSection key={topModule.type} hideXOverflow>
            <TopModuleSection
              topModule={topModule}
              locationName={locationNameForParkPage}
              id={details.id}
              pageType={pageType}
              ref={index === 0 ? ref : undefined} // Pass a ref to the first element rather than using a wrapping div because that breaks the flex spacing from the page container
              locationType={locationType}
            />
          </PageSection>
        );
      })}
    </>
  );
};

export default TopModule;
